import { http } from '.';

export interface UpdateStrokeRecordingPermissionRequest {
  email?: string;
  username?: string;
  allow_stroke_data_recording: boolean;
}

export interface UpdateStrokeRecordingPermissionResponse {
  success: boolean;
  message: string;
  user: {
    id: number;
    username: string;
    email: string;
    allow_stroke_data_recording: boolean;
  };
}

export async function updateStrokeRecordingPermission({
  email,
  username,
  allow_stroke_data_recording,
}: UpdateStrokeRecordingPermissionRequest): Promise<UpdateStrokeRecordingPermissionResponse> {
  console.log("📡 [Backend Call] Updating stroke recording permission:", {
    email,
    username,
    allow_stroke_data_recording,
  });

  const payload: any = {
    allow_stroke_data_recording,
  };
  
  if (email) {
    payload.email = email;
  }
  if (username) {
    payload.username = username;
  }

  const response = await http.post<UpdateStrokeRecordingPermissionResponse>('/update-stroke-recording-permission/', payload);

  console.log("📡 [Backend Response] Update stroke recording permission response:", response);
  return response;
}
